/*
 * @author: liaosir
 * @description: ae大促数据监控大屏地址
 */
import { APP_MODE } from 'ice';

const AE_SCREEN_URLS = {
  dev: 'https://datav.aliyuncs.com/share/45bc4410faeccf2de61f196cc3e391c7',
  test: 'https://datav.aliyuncs.com/share/45bc4410faeccf2de61f196cc3e391c7',
  stage: 'https://datav.aliyuncs.com/share/3f1717293fd6631e39f0fa09a3eb5249',
  prod: 'https://datav.aliyuncs.com/share/3f1717293fd6631e39f0fa09a3eb5249',
  us: 'https://datav.aliyuncs.com/share/3f1717293fd6631e39f0fa09a3eb5249',
  eu: 'https://datav.aliyuncs.com/share/3f1717293fd6631e39f0fa09a3eb5249',
  asia: 'https://datav.aliyuncs.com/share/3f1717293fd6631e39f0fa09a3eb5249',
  au: 'https://datav.aliyuncs.com/share/3f1717293fd6631e39f0fa09a3eb5249',
};

/**
 * @description ae大促数据监控大屏地址
 */
const AE_SCREEN_URL = AE_SCREEN_URLS[APP_MODE];

export { AE_SCREEN_URL };
